import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React from "react";
import { Link } from "react-router-dom"; 

const GlobalHiring = ({ services, customClass, heading }) => {
  return (
    <div className={`global-hiring-section ${customClass}`}>
      <h1>
      {heading.heading1}
        <br />
        {heading.heading2}
      </h1>
      <p> {heading.para1}
       <br />
       {heading.para2}
      </p>
      <div className="global-hiring-cards">
        {services.map((service, index) => (
          <div key={index} className="global-hiring-card">
            <div className="global-title-icon">
              <h3>{service.title}</h3>
              <FontAwesomeIcon icon={service.iconClass} className="icon-with-stroke" />
            </div>
            <p>{service.description}</p>
            <Link to={service.url}>
            <button>Read more →</button>
            </Link>
          </div>
        ))}
      </div>
    </div>
  );
};

export default GlobalHiring;
